const initialAssignmentsFilterState = {
  fetching: false,
  fetched: false,
  items: [],
  error: null,
  nbResult: 0
};

export const countEventAppTypeReducer = (state = initialAssignmentsFilterState, action) => {
  switch (action.type) {
    case "COUNT_EVENT_STATS_APP_TYPE_PENDING": {
      return {...state, fetched: false, fetching: true};
    }
    case "COUNT_EVENT_STATS_APP_TYPE_FULFILLED": {
      const {data, nbResult} = action.payload.data;
      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        items: data ? data : [],
        nbResult: nbResult
      };
    }

    case "COUNT_EVENT_STATS_APP_TYPE_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
      }
      return {
        ...state,
        fetching: false,
        items: [],
        nbResult: 0,
        error
      };
    }


    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./app/reducers/index/EventStats/countEventAppTypeReducer.js